.styledSubmitButton {
  align-self: flex-end;
}

.form {
  display: flex;
  flex-direction: column;
  width: var(--chat-message-width);
  max-width: var(--chat-message-width);
}

@property --bg-angle {
  inherits: false;
  initial-value: 0deg;
  syntax: '<angle>';
}

@keyframes spin {
  to {
    --bg-angle: 1turn;
  }
}

.loaderWrapper {
  &.isMessagePending {
    --bg-angle: 0turn;
    animation: spin 3s linear infinite;
    background:
      linear-gradient(var(--surface-default), var(--surface-default))
        padding-box,
      conic-gradient(from var(--bg-angle), transparent, var(--border-primary))
        border-box;
    border: 2px solid transparent;
    border-radius: 12px;
  }
}

.modesSwitcher {
  padding: 1px;
  background: var(--background-default);
  border-radius: inherit;
}

.footer {
  height: 100%;
}
